/**
 * Taça vazia — o ícone do "Já bebi".
 *
 * Desenhada em vez de emoji porque **não existe** emoji de taça vazia: 🍷 é
 * sempre cheio, e é o que as adegas usam. Só o traço, sem preenchimento: é
 * exatamente essa diferença que diz "esta garrafa já foi".
 *
 * Usa `currentColor`, então acompanha a cor de quem a contém.
 */
export function TacaVazia({ className = 'h-7 w-7' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
    >
      {/* Bojo vazio */}
      <path d="M7 3h10v4.5a5 5 0 0 1-10 0V3Z" />
      {/* Haste */}
      <path d="M12 12.5V19" />
      {/* Base */}
      <path d="M8.5 19h7" />
    </svg>
  );
}
